import { useCallback, useMemo } from 'react';
import { getCurrentProfileTier } from '~/services/profileTierService';
import type { ProfileTier } from '~/constants/profileTier';
import { useStateValue } from '~/store/store';
import { SET_CUSTOMER_PROFILE } from '~/store/actions';

export type ProfileTierState = {
    profileTier: ProfileTier;
    setProfileTier: (next: ProfileTier) => void;
};

// Hook-only implementation: derives and updates profileTier via AppProvider's store.
export const useProfileTier = (): ProfileTierState => {
    const { state, dispatch } = useStateValue();
    const profileTier = getCurrentProfileTier(state);
    const setProfileTier = useCallback(
        (next: ProfileTier) => {
            dispatch({
                type: SET_CUSTOMER_PROFILE,
                payload: {
                    customer: {
                        ...state.customer,
                        details: {
                            ...state.customer?.details,
                            profileTier: next,
                        },
                    },
                },
            });
        },
        [dispatch, state.customer]
    );
    return useMemo(() => ({ profileTier, setProfileTier }), [profileTier, setProfileTier]);
};
